import type { ServicesFeedbackType } from '~/components/page/LFA/state/servicesFeedbackState';
import { Lfa_Service_Acceptance_Status } from '~/graphql/types';

/**
 * Checks if feedback has any accepted services that will be invoiced
 * @param {ServicesFeedbackType} servicesFeedback
 * keywords: services, accepted, invoice
 */
const hasAcceptedServices = (
  servicesFeedback: ServicesFeedbackType,
): boolean => {
  if (!servicesFeedback) return false;
  if (!servicesFeedback.Event_Feedback_Done) return false;

  const hasAnyAcceptedServices =
    servicesFeedback.Event_Feedback_Done.services.some(service =>
      service.acceptance.some(
        acceptance =>
          acceptance.status === Lfa_Service_Acceptance_Status.Accepted,
      ),
    );

  return hasAnyAcceptedServices;
};
export default hasAcceptedServices;
